/* Default Colors */
/* CI/CD Colors */
/* 2021 TS Colors */
/* Scrollbars */
*:focus {
	outline: var(--oebb-outline, 2px dotted var(--oebb-accent-color, #e2002a));
	outline-offset: var(--oebb-outline-offset, 2px);
}

*:focus:not(:focus-visible) {
	outline: none;
}

*:focus-visible {
	outline: var(--oebb-outline, 2px dotted var(--oebb-accent-color, #e2002a));
	outline-offset: var(--oebb-outline-offset, 2px);
}

.hidden {
	display: none;
}

.invisible {
	visibility: hidden;
}

.offscreen {
	position: absolute;
	left: -1000em;
}

.screen-reader-text {
	position: absolute;

	width: 1px;
	height: 1px;
	margin: -1px;
	padding: 0;
	overflow: hidden;

	border: 0;
	clip-path: inset(50%);

	white-space: nowrap;
}

.screen-reader-text--focusable:active,
.screen-reader-text--focusable:focus {
	position: relative;

	width: auto;
	height: auto;
	margin: 0;
	overflow: visible;

	clip-path: none;

	white-space: inherit;
}

/** @deprecated */
/** ".is-tabbing" should be added via JavaScript and shows the outline. Used with class to not show outline on clicking elements. */
.is-tabbing button::-moz-focus-inner,
:host(.is-tabbing) button::-moz-focus-inner {
	border: 0;
}

.is-tabbing--focus,
.is-tabbing a:focus,
.is-tabbing button:focus,
.is-tabbing div:focus,
.is-tabbing input:focus,
.is-tabbing input:focus ~ span[role="presentation"],
:host(.is-tabbing) a:focus,
:host(.is-tabbing) button:focus,
:host(.is-tabbing) div:focus,
:host(.is-tabbing) input:focus,
:host(.is-tabbing) input:focus ~ span[role="presentation"] {
	outline: 2px dotted #e2002a;
	outline-offset: 2px;
	z-index: 10;
}
 /* Default Colors */
/* CI/CD Colors */
/* 2021 TS Colors */
/* Scrollbars */
.train-details {
  display: grid;
  grid-template-columns: 5fr 7fr;
  grid-template-rows: repeat(3, auto) 1fr auto;
  grid-template-areas: "operator operator" "offers offers" "timetable map" "timetable facilities" "fineprint fineprint";
  gap: 25px 55px;
}
@media screen and (max-width: 950px) {
  .train-details {
    grid-template-columns: 1fr;
    grid-template-rows: repeat(6, auto);
    grid-template-areas: "operator" "offers" "timetable" "map" "facilities" "fineprint";
  }
}
.train-details a {
  color: #e2002a;
  text-decoration: underline;
  font-weight: bold;
}
.train-details a:active, .train-details a:focus, .train-details a:hover {
  color: #666666;
}
.train-operator {
  grid-area: operator;
}
.train-offers {
  grid-area: offers;
  overflow: hidden;
  margin-left: -14px;
  padding-left: 14px;
}
.train-timetable {
  grid-area: timetable;
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.train-map {
  grid-area: map;
}
.train-facilities {
  grid-area: facilities;
  display: flex;
  flex-direction: column;
  gap: 15px;
  align-items: start;
}
.train-facilities-block {
  display: flex;
  gap: 6px;
  color: #666;
  font-size: 16px;
  padding: 15px;
  border: 1px solid #f5f5f5;
}
.train-facilities-block oebbx-icon svg {
  display: block;
  width: 20px;
  height: 20px;
}
.train-fineprint {
  grid-area: fineprint;
  font-size: 12px;
}
.train-seasonal {
  margin: 0;
  font-size: 18px;
  font-weight: bold;
  -webkit-font-smoothing: antialiased;
}
@media screen and (max-width: 540px) {
  .train-details {
    margin: 0 -1rem;
  }
}

.hidden {
  display: none;
}